import AccountSetupListItemNumber from './AccountSetupListItemNumber';

interface IProps {
  number: string;
  isSelected?: boolean;
  isCompleted?: boolean;
  title: string;
  text: string;
}

const AccountSetupListItem = (props: IProps) => {
  const { number, isSelected, title, text, isCompleted } = props;
  return (
    <div className={`h-fit flex my-10  ${isCompleted ? 'opacity-40' : null}`}>
      <AccountSetupListItemNumber isSelected={isSelected} text={number} isCompleted={isCompleted} />
      <div className="ml-14 h-auto flex flex-col justify-between py-1.5">
        <div className="text-16 leading-4 font-600">{title}</div>
        <div className="text-13 leading-3 mt-4 font-400">{text}</div>
      </div>
    </div>
  );
};

export default AccountSetupListItem;
